import {SimpleForm, useTranslate, Toolbar, SaveButton, useRefresh, TextInput, required, minLength, maxLength} from "react-admin";
import {Typography} from "@mui/material";
import {EditInDialogButton} from "@react-admin/ra-form-layout";
import * as React from "react";
import {Transition} from "../OrderReturnShow";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import {returnStates} from "../returnStates";

const DeclineRequestDialog = (props: { transition: Transition, language: string | undefined }) => {
    const t = useTranslate();
    const refresh = useRefresh();

    const {transition, language} = props;
    const status = returnStates[transition.target];
    const languageString = t(`resources.order.return.${language}Language`);

    return (
        <EditInDialogButton
            title={`resources.order.return.transitions.${transition.id}ConfirmationTitle`}
            mutationMode="pessimistic"
            mutationOptions={{
                onMutate: (mutate) => {
                    mutate.id = `${mutate.id}/transitions`;
                    return mutate;
                },
                onSuccess: () => {
                    refresh();
                }
            }}
            ButtonProps={
                {
                    label: `resources.order.return.transitions.${transition.id}`,
                    startIcon: false,
                    color: status.color === 'default' ? 'inherit' : status.color,
                }
            }
        >
            <SimpleForm
                toolbar={
                    <Toolbar>
                        <SaveButton label={`ra.action.confirm`} icon={<ThumbUpIcon/>} alwaysEnable/>
                    </Toolbar>
                }
                record={{transition: transition.id}}
            >
                <Typography variant="body1" gutterBottom>
                    {t(`resources.order.return.transitions.${transition.id}ConfirmationDesc`, {language: languageString})}
                </Typography>
                <TextInput
                    multiline
                    fullWidth
                    source="reason"
                    label="resources.order.return.declineReason"
                    validate={[required(), minLength(10), maxLength(500)]}
                    sx={{height: '140px',  '& textarea': { height: '100px !important;' }}}
                />
            </SimpleForm>
        </EditInDialogButton>
    );
};

export default DeclineRequestDialog;
